// extracted by mini-css-extract-plugin
export default {"search-bar-container-home-page":"P6p_w","searchBarContainerHomePage":"P6p_w"};